const STORAGE_KEY = 'oi_exp_override';
const PAIR = /^([a-z][a-z0-9_]{2,63}):([a-z][a-z0-9_]{0,63})$/;
export function readOverrides(storage, search) {
    const stored = storage.getJson(STORAGE_KEY);
    let current = stored && (stored.off === true || (stored.off === false && typeof stored.variants === 'object'))
        ? stored
        : { off: false, variants: {} };
    let raw = null;
    try {
        raw = new URLSearchParams(search).get('oi_exp');
    }
    catch {
        raw = null;
    }
    if (raw == null)
        return current;
    const value = raw.trim().toLowerCase();
    if (value === 'reset') {
        storage.remove(STORAGE_KEY);
        return { off: false, variants: {} };
    }
    if (value === 'off') {
        current = { off: true };
    }
    else {
        const variants = current.off ? {} : { ...current.variants };
        for (const part of value.split(',')) {
            const match = PAIR.exec(part.trim());
            if (match?.[1] && match[2])
                variants[match[1]] = match[2];
        }
        current = { off: false, variants };
    }
    storage.setJson(STORAGE_KEY, current);
    return current;
}
